module.exports = __webpack_public_path__ + "static/media/img-14.07a14d33.png";